// Scenario 3c: restricted_us
// Same tenant as past_due_us but status = 'unpaid', gracePeriodEndsAt is in the past.
// Feature gating active per #06: AI chat blocked, create-record blocked,
// background jobs paused. Reads, exports, settings, billing routes still accessible.

import { pastDueUs } from './past-due-us.fixture';
import { Scenario, daysFromNow } from './scenario.types';

export const restrictedUs: Scenario = {
  ...pastDueUs,
  name: 'restricted_us',
  subscription: pastDueUs.subscription
    ? {
        ...pastDueUs.subscription,
        id: 'sub_restricted_us',
        status: 'unpaid',
        pastDueSince: daysFromNow(-10),
        gracePeriodEndsAt: daysFromNow(-3)
      }
    : null
};
